import CollectionDataGrid from '@/components/CollectionDataGrid'
import { pbUpsert, useCollection } from '@/pb'
import { arrayToObject, objectMap, useInputState } from '@/utils'
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, LinearProgress, MenuItem, Select, TextField } from '@mui/material'
import { useMemo } from 'react'

const Editor = ({ row, onClose }) => {
  const [manufacturers, manufacturersLoaded] = useCollection('manufacturers')

  const [name, setName] = useInputState(row?.name)
  const [manufacturer, setManufacturer] = useInputState(row?.manufacturer)

  const canSave = Boolean(name && manufacturer)

  if (!manufacturersLoaded) return <LinearProgress />

  return <>
    <DialogTitle>Продукт</DialogTitle>
    <DialogContent className="editorForm">
      <TextField label={fields.code.headerName} value={row?.code} disabled />
      <FormControl>
        <InputLabel id="manufacturer">{fields.manufacturerName.headerName}</InputLabel>
        <Select
          labelId="manufacturer"
          value={manufacturer}
          label={fields.manufacturerName.headerName}
          onChange={setManufacturer}
        >
          {Object.entries(manufacturers).map(([id, { name }]) =>
            <MenuItem value={id}>{name}</MenuItem>
          )}
        </Select>
      </FormControl>


      <TextField label={fields.name.headerName} value={name} onChange={setName} />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} >Отмена</Button>
      <Button onClick={() => pbUpsert('products', { id: row?.id, name, manufacturer }).then(onClose)} variant="contained" disabled={!canSave}>Сохранить</Button>
    </DialogActions>
  </>
}

const columns = [
  { field: 'code', headerName: 'Код', width: 100 },
  { field: 'name', headerName: 'Наименование', width: 300 },
  { field: 'manufacturerName', headerName: 'Производитель', width: 300 },
]
const fields = arrayToObject(columns, 'field')

export default function Products({ title }) {

  const [products, productsLoaded] = useCollection('products')
  const [manufacturers, manufacturersLoaded] = useCollection('manufacturers')

  const productsWithManufacturers = useMemo(() => {
    return objectMap(products, product => ({
      ...product,
      manufacturerName: manufacturers[product.manufacturer]?.name,
      code: manufacturers[product.manufacturer]?.code?.toString(16).padStart(3, '0') + '-' + product.code.toString(16).padStart(3, '0'),
    }))
  }, [products, manufacturers])

  return (
    <CollectionDataGrid
      collectionName={title}
      collection={productsWithManufacturers}
      columns={columns}
      loading={!productsLoaded || !manufacturersLoaded}
      editor={Editor}
    />
  )

}